import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
	selector: 'cancel-btn',
	template: require('./cancel-btn.html')
})
export class CancelBtnComponent {
	@Output() action: EventEmitter<any> = new EventEmitter();
	@Input('isDisabled') isDisabled: boolean;

	constructor() {}

	onBtnClick() {
		this.action.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./mobile/src/components/buttons/cancel-btn/cancel-btn.ts